<script setup lang="ts">
import {KLEUR_CEL, StatusKleur, StatusMatrix} from 'common';

defineProps<{
    matrix: StatusMatrix;
    titel?: string;
    kopLabel?: string;
}>();

function achtergrond(kleur: StatusKleur): string {
    return kleur === StatusKleur.grijs ? '' : KLEUR_CEL[kleur];
}
</script>

<template>
    <div class="flex flex-col gap-2">
        <div v-if="titel" class="text-xl font-semibold text-zzc-blue">{{ titel }}</div>
        <div class="overflow-x-auto">
            <table class="text-sm border-collapse bg-white">
                <thead>
                    <tr class="bg-zzc-blue text-white">
                        <th class="text-left px-3 py-2 font-semibold">{{ kopLabel ?? 'KPI' }}</th>
                        <th v-for="k in matrix.kolommen" :key="k" class="px-3 py-2 font-semibold whitespace-nowrap">{{ k }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rij, i) in matrix.rijen" :key="i" :class="rij.totaal ? 'bg-gray-100 font-semibold' : 'border-b border-gray-100'">
                        <td class="px-3 py-1.5 whitespace-nowrap" :class="rij.detail ? 'pl-8 text-gray-500' : ''">{{ rij.label }}</td>
                        <td v-for="(cel, j) in rij.cellen"
                            :key="j"
                            class="px-3 py-1.5 text-center whitespace-nowrap"
                            :style="{backgroundColor: rij.totaal ? '' : achtergrond(cel.kleur)}"
                        >
                            {{ cel.tekst }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
